import ExternalLink from 'components/ExternalLink/ExternalLink.component';
import React from 'react';
import { MenuCardProps } from './MenuCard.type';
import { MenuCardLink, MenuCardText } from './style/MenuCard.style';

const MenuCard: React.FC<MenuCardProps> = function ({
  menuCard,
  ...otherProps
}) {
  return (
    <ExternalLink
      anchorElement={<MenuCardLink menuCard={menuCard} />}
      {...otherProps}
      href={menuCard.cardLink ?? '#'}
      noReferrer={false}
      target="_self"
    >
      <MenuCardText menuCard={menuCard}>{menuCard.cardText}</MenuCardText>
    </ExternalLink>
  );
};

export default MenuCard;
